export enum ProtocolEnum {
    TCP = "TCP",
    UDP = "UDP",
    AH = "AH",
    ESP = "ESP",
    ICMP = "ICMP",
}